import React, { useRef, useEffect } from "react";

const CONFIG = {
  starCountLarge: 169,
  starCountSmall: 569,  
  mobileBreakpoint: 600,
};

function generateStars(width, height, count) {
  return Array.from({ length: count }, () => ({
    x: Math.random() * width,
    y: Math.random() * height,
    r: 1 + Math.random() * 1.5,       // radius
    speed: 0.5 + Math.random() * 1.0, // twinkle speed
    phase: Math.random() * Math.PI * 2,
    baseAlpha: 0.3 + Math.random() * 0.4,
  }));
}

const BreathingStars = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx    = canvas.getContext("2d");

    let w = window.innerWidth;
    let h = window.innerHeight;
    let stars = [];

    const handleResize = () => {
      w = window.innerWidth;
      h = window.innerHeight;
      canvas.width  = w;
      canvas.height = h;

      const count = w < CONFIG.mobileBreakpoint
        ? CONFIG.starCountSmall
        : CONFIG.starCountLarge;
      stars = generateStars(w, h, count);
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    let rafId;
    const render = (t) => {
      ctx.clearRect(0, 0, w, h);
      const time = t * 0.001;

      stars.forEach((star) => {
        // static if reduced‑motion, otherwise breathe
        const alpha = prefersReduced
          ? star.baseAlpha
          : star.baseAlpha * (0.5 + 0.5 * Math.sin(time * star.speed + star.phase));

        ctx.globalAlpha = alpha;
        ctx.beginPath();
        ctx.arc(star.x, star.y, star.r, 0, Math.PI * 2);
        ctx.fillStyle = "#ffffff";
        ctx.fill();
      });

      if (!prefersReduced) {
        rafId = requestAnimationFrame(render);
      }
    };

    // kick off
    rafId = requestAnimationFrame(render);

    return () => {
      window.removeEventListener("resize", handleResize);
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="fixed inset-0 w-full h-full pointer-events-none z-0"
      aria-hidden="true"
    />
  );
};

export default BreathingStars; 